/**
 * Mesure émise par un bloc (03/10/2026) : le bloc signale un geste
 * (formulaire commencé, envoyé) par un événement DOM, sans rien savoir des
 * outils de mesure ni du consentement. Le site l'écoute
 * (src/components/site/tracking.ts) et ne le transmet à Google Analytics et
 * PostHog qu'après l'accord du visiteur. Hors du site (Storybook, démos),
 * personne n'écoute : l'événement se perd sans effet.
 */

/** Nom de l'événement DOM émis sur `window`. */
export const TRACK_EVENT = "yp:track";

export type TrackDetail = { event: string; props?: Record<string, string> };

/** Signale un geste à mesurer (`generate_lead`, `form_start`…). */
export function emitTrack(event: string, props?: Record<string, string>): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<TrackDetail>(TRACK_EVENT, { detail: { event, props } }));
}
